import { fontConfig } from "@conklin/XDL/PreStyle/typography";
import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import transformContentHtml from "@insite/client-framework/Common/Utilities/transformContentHtml";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import parse from "html-react-parser";
import * as React from "react";
import { css } from "styled-components";

type Props = WidgetProps & HasProduct;

export interface ProductDetailsMarketingDescriptionStyles {
    description?: TypographyPresentationProps;
}

export const descriptionStyles: ProductDetailsMarketingDescriptionStyles = {
    description: {
        size: 14,
        forwardAs: "p",
        lineHeight: "22px",
        css: css`
            margin-bottom: 12px;
        `,
    },
};

const styles = descriptionStyles;

const ProductDetailsMarketingDescription: React.FC<Props> = ({ product }) => {
    if (!product.properties.marketingDescription) {
        return null;
    }

    return <Typography {...styles.description}>{product.properties.marketingDescription}</Typography>;
};

const widgetModule: WidgetModule = {
    component: withProduct(ProductDetailsMarketingDescription),
    definition: {
        displayName: "Marketing Description",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
